import { render, staticRenderFns } from "./CctvComponent.vue?vue&type=template&id=571b64d9"
import script from "./CctvComponent.vue?vue&type=script&lang=js"
export * from "./CctvComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports